
import React, { useState, useEffect, useRef } from "react";
// import Header from "../common/components/Header";
import { useNavigate } from "react-router-dom"; // Add this at the top
import "./Alliteams.css";
import Ordercart from "./Ordercart";
// import "./NavBars"
// import Footer from "../common/components/Footer";

import { Link } from "react-router-dom";

import { FaCommentAlt, FaChevronDown, FaChevronUp } from "react-icons/fa";

import 'semantic-ui-css/semantic.min.css';

import axios from 'axios';
import { FaUser, FaShoppingCart, FaCreditCard, FaList, FaHeart, FaMapMarkerAlt, FaBell, FaHeadset, FaCog } from "react-icons/fa";

import { useLocation } from 'react-router-dom';
import Briyani from "../../../../images/products/Briyani.jpg";
import Staters from "../../../../images/products/starters2.jpg";
import Dosa from "../../../../images/products/Dosa.jpg";
import Meals from "../../../../images/products/meals.jpg";

import allCartsImage from "../../../../images/products/meals.jpg"; // Adjust the path as needed

// import Biryanidata from './Biryanidata';
const Cartsdata = () => {
    const orderPosts = [
        { dishId: 1, orderId: '12345', orderType: 'Dine-In' },
        { dishId: 2, orderId: '12346', orderType: 'Take Away' },
        { dishId: 3, orderId: '12347', orderType: 'Delivery' },
        { dishId: 1, orderId: '12345', orderType: 'Dine-In' },
        { dishId: 2, orderId: '12346', orderType: 'Take Away' },
        { dishId: 3, orderId: '12347', orderType: 'Delivery' },
        { dishId: 1, orderId: '12345', orderType: 'Dine-In' },
        { dishId: 2, orderId: '12346', orderType: 'Take Away' },
        { dishId: 3, orderId: '12347', orderType: 'Delivery' },
    ];
    const getOrderColor = (orderType) => {
        switch (orderType) {
            case "Dine-In":
                return "#1E90FF"; // Blue
            case "Take Away":
                return "#FF6347"; // Tomato
            case "Delivery":
                return "#20B2AA"; // LimeGreen
            default:
                return "#ccc"; // Grey
        }
    };
    // const [activeCategory, setActiveCategory] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [parentId, setParentId] = useState(null);
    // const [activeCategory, setActiveCategory] = useState("Allitems");
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [isVegSelected, setIsVegSelected] = useState(false);
    const [isNonVegSelected, setIsNonVegSelected] = useState(false);
    // const [quantities, setQuantities] = useState({});
    const [quantities, setQuantities] = useState({}); // Track quantities of items
    const [showPopup, setShowPopup] = useState(false);
    const [popupItem, setPopupItem] = useState(null);
    const [items, setItems] = useState([]); // Store API data
    // const [quantities, setQuantities] = useState({}); // Manage quantity state
    const [categories, setCategories] = useState([]);
    const [isHovered, setIsHovered] = useState(false);
    const [dishes, setDishes] = useState([]);  // Added state for dishes
    const location = useLocation();
    const [posts, setPosts] = useState([]);
    // const [activeCategory, setActiveCategory] = useState("Allcarts");
    const navigate = useNavigate(); // Define navigate
    const [filteredItems, setFilteredItems] = useState([]);
    const [cartData, setCartData] = useState([]);
    // const [allCategories, setAllCategories] = useState(["Allcarts"]);
    // const [activeCategory, setActiveCategory] = useState("Allcarts");
    const [allCategories, setAllCategories] = useState(["Allcarts"]);
    const [activeCategory, setActiveCategory] = useState("Allcarts");
    // Fetch Cart Data
    // Fetch Cart Data
    const isMobile = window.innerWidth <= 768;
    const [selectedDishId, setSelectedDishId] = useState(null); // Store the selected dishId
    const [cartItems, setCartItems] = useState([]);
    const [selectedCartId, setSelectedCartId] = useState(null);
    const [refresh, setRefresh] = useState(false);  // ✅ Define refresh state
    const handleCategoryClick = (category) => {
        setActiveCategory(category);

        // Ensure React updates the state immediately
        setFilteredItems(prevItems => {
            if (category === "Allcarts") return cartData;
            return cartData.filter(item => item.dishName === category);
        });

        // 🔥 Force Re-Render Immediately
        setTimeout(() => setRefresh(prev => !prev), 0);
    };

    // ✅ Trigger re-fetch when `refresh` changes
    useEffect(() => {
        let selectedItems = activeCategory === "Allcarts"
            ? cartData
            : cartData.filter(item => item.dishName === activeCategory);

        setFilteredItems([...selectedItems]);
    }, [activeCategory, cartData, refresh]); // ✅ Added `refresh` to dependencies

    // ✅ Fetch data function (runs in the background)




    // ✅ Track when `selectedCartId` and `selectedDishId` become available
    useEffect(() => {
        if (!selectedCartId || !selectedDishId) {
            console.warn("⏳ Waiting for selectedCartId and selectedDishId to be set...");
            return;
        }
        console.log("✅ selectedCartId and selectedDishId are now available");
    }, [selectedCartId, selectedDishId]); // ✅ Runs when these values change

    // ✅ Effect to Filter Items When `activeCategory` Changes


    // ✅ Effect to Fetch API Data When IDs and Category Are Set


    useEffect(() => {
        console.log("📡 useEffect triggered to fetch cart data");

        const fetchCart = async () => {
            const userId = localStorage.getItem("userId");
            const vendorId = localStorage.getItem("vendorId") || "1";
            const token = localStorage.getItem("authToken");

            console.log("🔍 LocalStorage values:", { userId, vendorId, token });

            try {
                const response = await fetch(`https://backend.maamaas.com/food/cart/get/${vendorId}`, {
                    headers: token ? { Authorization: `Bearer ${token}` } : {},
                });

                const tokenFromHeader = response.headers.get("authorization");
                if (tokenFromHeader) {
                    localStorage.setItem("authToken", tokenFromHeader);
                }

                const data = await response.json();

                if (data.token) {
                    localStorage.setItem("authToken", data.token);
                }

                console.log("🛒 Cart Data:", data);

                const cartItems = data.cartItems || [];

                setCartData(cartItems);
                setAllCategories(["Allcarts", ...new Set(cartItems.map(item => item.dishName))]);
                setFilteredItems(cartItems);

            } catch (err) {
                console.error("❌ Error fetching cart data:", err);
            }
        };

        fetchCart();
    }, []);

    useEffect(() => {
        const fetchCartData = async () => {
            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken"); // include if API requires auth

            if (!vendorId) {
                console.error("🚨 Vendor ID not found in localStorage!");
                return;
            }

            try {
                const response = await axios.get(
                    `https://backend.maamaas.com/food/api/cart/vendor/${vendorId}`,
                    {
                        headers: token ? { Authorization: `Bearer ${token}` } : {},
                    }
                );

                console.log("🛒 Cart Data:", response.data);

                const items = response.data.cartItems || [];
                setCartData(items);
                setFilteredItems(items);

                // Extract unique categories (dishName or category field)
                const categories = [...new Set(items.map(item => item.dishName))];
                setAllCategories(["Allcarts", ...categories]);

                // Handle quantities
                const savedQuantities = JSON.parse(localStorage.getItem("cartQuantities") || "{}");
                const updatedQuantities = {};

                items.forEach((item) => {
                    const dishId = item.itemId || item.dishId || item.id;
                    updatedQuantities[dishId] = item.quantity ?? item.qty ?? savedQuantities[dishId] ?? 1;
                });

                setQuantities(updatedQuantities);
                localStorage.setItem("cartQuantities", JSON.stringify(updatedQuantities));

            } catch (error) {
                console.error("❌ Error fetching cart data:", error);
                if (error.response) {
                    console.error("📛 Response Error:", error.response.data);
                } else if (error.request) {
                    console.error("📛 No Response from server:", error.request);
                } else {
                    console.error("📛 General Error:", error.message);
                }
            }
        };

        fetchCartData();
    }, []);








    useEffect(() => {
        if (activeCategory === "Allcarts") {
            setFilteredItems(cartData); // ✅ Show all items
        } else {
            const filtered = cartData.filter(item => item.dishId === activeCategory);
            setFilteredItems(filtered);
        }
    }, [activeCategory, cartData]); // ✅ Depend on activeCategory and cartData


    // Static categories with "Allcarts"
    const staticCategories = ["Allcarts"];

    // Dynamic categories from API (Extract dish names)
    const dynamicCategories = [...new Set(cartData.map(item => item.dishName))];










    const iconMap = {
        Allcarts: <FaShoppingCart />,
        Biryani: <img src={Briyani} alt="Briyani" style={{ width: '100px', height: '100px', borderRadius: '50%' }} />,
        Staters: <img src={Staters} alt="Staters" style={{ width: '100px', height: '100px', borderRadius: '50%' }} />,
        Dosa: <img src={Dosa} alt="Dosa" style={{ width: '100px', height: '100px', borderRadius: '50%' }} />,
        Meals: <img src={Meals} alt="Meals" style={{ width: '100px', height: '100px', borderRadius: '50%' }} />,

    };


    const handleFilterClick = (type) => {
        if (type === "Veg") {
            setIsVegSelected(true);
            setIsNonVegSelected(false);
        } else if (type === "Non-veg") {
            setIsNonVegSelected(true);
            setIsVegSelected(false);
        } else {
            setIsVegSelected(false);
            setIsNonVegSelected(false);
        }
    };

    const currentCategoryItems = categories[activeCategory] || [];
    const addToCarts = (id) => {
        setQuantities((prev) => ({ ...prev, [id]: 1 })); // Set initial quantity to 1
        setPopupItem(filteredItems.find((item) => item.id === id)); // Store clicked item
        setShowPopup(true);
    };

    const increaseQuantity = (id) => {
        setQuantities((prev) => ({ ...prev, [id]: (prev[id] || 0) + 1 }));
    };

    const decreaseQuantity = (id) => {
        setQuantities((prev) => {
            const newQuantity = (prev[id] || 0) - 1;
            if (newQuantity <= 0) {
                const updatedQuantities = { ...prev };
                delete updatedQuantities[id]; // Remove item if quantity is 0
                return updatedQuantities;
            }
            return { ...prev, [id]: newQuantity };
        });
    };


    const scrollContainerRef = useRef(null);









    const getIconClassNames = (category) => {
        switch (category) {
            case "Allcarts":
                return "user";
            case "Biryani":
                return "shopping cart";
            case "Payments":
                return "credit card";
            case "Orders":
                return "list";
            case "Favorites":
                return "heart";
            case "Notifications":
                return "bell";
            case "Address":
                return "map marker alternate"
            case "Customer support":
                return "comments"
            case "Settings":
                return "settings"
            default:
                return "";
        }
    };




    return (
        <>
            <div className="container-fluid">
                <div className="row" style={{ marginTop: "50px" }}>
                    <div className="col-lg-2 col-md-3 col-sm-3 col-3">
                        {/* 📌 Desktop View: Category Cards */}
                        <div
                            className="category-sidebar d-none d-sm-block mobile-scrolling-cart"  // Hide on mobile
                            style={{
                                maxHeight: "600px",
                                position: "sticky",
                                top: "0px",
                                marginTop: "5px",
                                zIndex: 1000,
                                width: "180px",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",
                            }}
                        >
                            <div className="category-container" style={{
                                overflowY: "auto",
                                height: "556px",
                                marginTop: "68px",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",
                            }}>
                                {allCategories.map((category, index) => {
                                    const categoryImage =
                                        category === "Allcarts"
                                            ? allCartsImage
                                            : `data:image/png;base64,${cartData.find(item => item.dishName === category)?.dishImage || ""}`;

                                    return (
                                        <div
                                            key={index}
                                            className="category-card"
                                            onClick={() => handleCategoryClick(category)}
                                            style={{
                                                backgroundColor: activeCategory === category ? "rgb(177 93 198)" : "#D9D9D9",
                                                margin: "8px 0",
                                                padding: "10px",
                                                display: "flex",
                                                alignItems: "center",
                                                flexDirection: "column",
                                                cursor: "pointer",
                                                justifyContent: "center",
                                                borderRadius: "15px",
                                                transition: "0.3s ease-in-out",
                                                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                                height: "165px"
                                            }}
                                        >
                                            <img
                                                src={categoryImage}
                                                alt={category}
                                                style={{
                                                    width: "100px",
                                                    height: "100px",
                                                    borderRadius: "50%",
                                                    objectFit: "cover",
                                                }}
                                            />
                                            <div className="category-card-body d-flex justify-content-center p-0">
                                                <button
                                                    style={{
                                                        backgroundColor: activeCategory === category ? "#ddd" : "#fff", // Slight color change for active state
                                                        margin: "5px",
                                                        padding: "8px",
                                                        borderRadius: "10px",
                                                        cursor: "pointer",
                                                        transition: "0.3s ease-in-out",
                                                    }}

                                                >
                                                    {category}
                                                </button>
                                            </div>

                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        {/* 📌 Mobile View: Dropdown */}


                    </div>
                    <div className="d-block d-sm-none " style={{ marginTop: "65px", width: "100%" }}>
                        <select
                            className="form-control "
                            onChange={(e) => handleCategoryClick(e.target.value)}
                            value={activeCategory}
                            style={{
                                padding: "8px",
                                borderRadius: "10px",
                                border: "1px solid #ccc",
                                width: "100%",
                                background: "#b15dc6",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "20px"
                            }}
                        >
                            {allCategories.map((category, index) => (
                                <option key={index} value={category}>
                                    {category}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-lg-7 col-md-7 col-sm-12 col-12" >
                        <p
                            className="breadcrumb maamaas-home-bredcum"
                            style={{
                                position: "fixed",
                                top: isMobile ? "50px" : "80px",
                                left: isMobile ? "5px" : "275px",
                                width: "100%",
                                backgroundColor: "#fff",
                                zIndex: 1000,
                                padding: "10px 0",
                                fontSize: isMobile ? "14px" : "18px",
                                fontWeight: isMobile ? "normal" : "bold",
                                textAlign: "center",
                                margin: 0,

                            }}
                        >
                            <Link
                                to="/mainladdingpage"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Home
                            </Link>
                            <span className="separator"> &gt; </span>
                            <Link
                                to="/company"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                DigitalMenuBillings
                            </Link>
                            <span className="separator"> &gt; </span>
                            <Link
                                to="/menu"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Menu
                            </Link>
                            <span className="separator"> &gt; </span>
                            <Link
                                to="/cartsdata"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Cart
                            </Link>

                        </p>
                        <div className="cartsizes"
                            style={{
                                marginTop: "100px",
                                padding: "20px",
                                borderRadius: "8px",
                            }}
                        >
                            {/* ✅ Show Ordercart Component When a Category is Clicked */}
                            {/* {filteredItems.length > 0 && ( */}
                            <Ordercart key={activeCategory} filteredDataProp={filteredItems} />



                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                            <div
                                style={{
                                    position: "fixed",
                                    bottom: "20px",
                                    right: "16px",
                                    top: "40px",
                                    width: "320px",
                                    height: "595px",
                                    borderRadius: "8px",
                                    marginTop: '40px',
                                    padding: "10px",
                                }}
                                className="scroll-fixed-data mobilescroll"
                            >
                                <div
                                    // ref={scrollContainerRef}
                                    style={{
                                        maxHeight: "550px",
                                        overflowY: "auto",
                                        paddingRight: "5px",
                                        scrollbarWidth: "none",
                                        msOverflowStyle: "none",
                                        marginTop: "30px",
                                    }}
                                    className="hide-scrollbar"
                                    onMouseEnter={() => setIsHovered(true)}
                                    onMouseLeave={() => setIsHovered(false)}
                                >
                                    {/* Original Data */}
                                    {orderPosts.map((post, index) => (
                                        <div
                                            key={`${post.dishId}-${index}`}
                                            className="card scroll-data-responsive"
                                            style={{
                                                width: "300px",
                                                height: "120px",
                                                marginBottom: "10px",
                                                background: getOrderColor(post.orderType),
                                                borderRadius: "8px",
                                                boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
                                                overflow: "hidden",
                                                padding: "0px",
                                                position: "relative",
                                            }}
                                        >
                                            <div style={{ position: "relative", width: "100%", height: "100%" }}>


                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        top: "10px",
                                                        left: "90px",
                                                        color: "#fff",
                                                        fontWeight: "bold",

                                                        borderRadius: "5px",
                                                        display: 'flex',
                                                        justifyContent: "start",
                                                    }}
                                                >
                                                    <h5 style={{ marginLeft: '-60px' }}>{post.orderType}</h5>
                                                    <p style={{ marginLeft: '40px' }}>Order ID: #{post.orderId}</p>
                                                </div>

                                                <button
                                                    style={{
                                                        position: "absolute",
                                                        top: "70px",
                                                        right: "-5%",
                                                        transform: "translateX(-50%)",
                                                        padding: "8px",
                                                        backgroundColor: "rgb(177 93 198)",
                                                        color: "white",
                                                        fontSize: "14px",
                                                        fontWeight: "bold",
                                                        border: "none",
                                                        borderRadius: "5px",
                                                        cursor: "pointer",
                                                        zIndex: "10",
                                                    }}
                                                >
                                                    Decline
                                                </button>
                                                <button
                                                    style={{
                                                        position: "absolute",
                                                        top: "70px",
                                                        left: "20%",
                                                        transform: "translateX(-50%)",
                                                        padding: "8px",
                                                        backgroundColor: "rgb(177 93 198)",
                                                        color: "white",
                                                        fontSize: "14px",
                                                        fontWeight: "bold",
                                                        border: "none",
                                                        borderRadius: "5px",
                                                        cursor: "pointer",
                                                        zIndex: "10",
                                                    }}
                                                >
                                                    Accept
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>



                        {/* <div
                            style={{
                                backgroundColor: "#007bff",
                                color: "#fff",
                                padding: "10px",
                                fontWeight: "bold",
                                textAlign: "center",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                cursor: "pointer",
                                position: "fixed",
                                bottom: isOpen ? "420px" : "30px",
                                right: "20px",
                                width: "20%",
                                borderRadius: "8px",
                                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                transition: "bottom 0.3s ease-in-out",
                            }}
                            className="chat-box-name-data"
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            <FaCommentAlt style={{ marginLeft: "10px" }} />
                            <span style={{ flexGrow: 1, textAlign: "center" }}>Chat Support</span>
                            {isOpen ? <FaChevronDown style={{ marginRight: "10px" }} /> : <FaChevronUp style={{ marginRight: "10px" }} />}
                        </div> */}

                        {/* Chatbox Content */}
                        {/* <div
                            style={{
                                position: "fixed",
                                bottom: isOpen ? "20px" : "-400px",
                                right: "20px",
                                width: "20%",
                                height: "400px",
                                backgroundColor: "#fff",
                                borderRadius: "8px",
                                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                padding: "10px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                transition: "bottom 0.3s ease-in-out",
                            }}

                        >
                            <div style={{ flexGrow: 1, overflowY: "auto", padding: "10px", fontSize: "14px" }}>
                                <p style={{ textAlign: "center" }}>How can we help you?</p>
                            </div>

                            <textarea
                                placeholder="Type here..."
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                    resize: "none",
                                    height: "44px",
                                    fontSize: "14px",
                                }}
                            />
                        </div> */}
                    </div>


                </div>



            </div>
        </>
    );
};

export default Cartsdata;
